export default "__VITE_ASSET__9757bda0__"